// extracted by mini-css-extract-plugin
export default {"outer_container":"ImageSlider_outer_container__symIW","slider_container":"ImageSlider_slider_container__4m6aF"};